import * as CONST from "./actionTypes";

const intialState = {
  isLogin: false,
  loading: false,
  documents: [],
  editDocuments: [],
  // blockUnblockUser: [],
  deleteDocuments: [],
  updateDocuments: [],
  error: null,
};

const DocumentsReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.DOCUMENTS_LIST:
      return {
        ...state,
        isLogin: true,
        loading: true,
        error: null,
      };
    case CONST.DOCUMENTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: payload,
        error: null,
      };
    case CONST.DOCUMENTS_LIST_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };

    /* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.EDIT_DOCUMENTS:
      return {
        ...state,
        isLogin: true,
        loading: true,
        error: null,
      };
    case CONST.EDIT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        editDocuments: payload,
        error: null,
      };
    case CONST.EDIT_DOCUMENTS_FAIL:
      return {
        ...state,
        loading: true,

        error: payload,
      };
    /* >>>>>>>>>>>>>> UPDATE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_DOCUMENTS:
      return {
        ...state,
        isLogin: true,
        loading: true,
        error: null,
      };
    case CONST.UPDATE_DOCUMENTS_SUCCESS:
      return {
        ...state,

        loading: true,
        updateDocuments: { ...payload },
        error: null,
      };
    case CONST.UPDATE_DOCUMENTS_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };
    /* >>>>>>>>>>>>>> ADD CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.ADD_DOCUMENTS:
      return {
        ...state,
        isLogin: true,
        loading: true,

        error: null,
      };
    case CONST.ADD_DOCUMENTS_SUCCESS:
      return {
        ...state,

        loading: true,
        addDocuments: { ...payload },
        error: null,
      };
    case CONST.ADD_DOCUMENTS_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };
    /* >>>>>>>>>>>>>> BLOCK_UNBLOCK CUSTOMER >>>>>>>>>>>>>>>*/

    // case CONST.BLOCK_UNBLOCK_USER:
    //   return {
    //     ...state,
    //     isLogin: true,
    //     loading: true,

    //     error: null,
    //   };
    // case CONST.BLOCK_UNBLOCK_USER_SUCCESS:
    //   return {
    //     ...state,

    //     loading: true,
    //     blockUnblockUser: payload,
    //     error: null,
    //   };
    // case CONST.BLOCK_UNBLOCK_USER_FAIL:
    //   return {
    //     ...state,
    //     loading: false,

    //     error: payload,
    //   };

    /* >>>>>>>>>>>>>> DELETE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.DELETE_DOCUMENTS:
      return {
        ...state,
        isLogin: true,
        loading: true,

        error: null,
      };
    case CONST.DELETE_DOCUMENTS_SUCCESS:
      return {
        ...state,

        loading: true,
        deleteDocuments: payload,
        error: null,
      };
    case CONST.DELETE_DOCUMENTS_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default DocumentsReducer;
